<template src="./StatsMaincategory.html"></template>

<script>
import axios from 'axios';
const d3 = require('d3');
const c3 = require('c3');

export default {
  name: 'statsMaincategory',
  data () {
    return {
      vG2l: 1,
      vG2r: 1,
      vG3l: 1,
      vG3r: 1,
      vG4l: 1,
      vG4r: 1,
      settings: 0,
      loaderSm: 0,
      yearslist: [],
      names: {
        hatg: '',
        atg: '',
        brand: ''
      },
      categories: [],
      subcategories: [],
      brands: [],
      year: '',
      sort: 'revenues',
      showAll: 0,
      colors: ['hggh','hghghghghg','nbcnb','nbcnb','cvbnvcnc'],
      chartData: [["Jan", 4], ["Feb", 2], ["Mar", 10], ["Apr", 5], ["May", 3]],
      chartData1: [["Jan", 4], ["Feb", 2], ["Mar", 10], ["Apr", 5], ["May", 3]],
      showmore: 0,
    }
  },
  mounted: function() {
    this.fetchData()

    if(!this.$route.params.year) {
      let date = new Date();      
      this.year = date.getFullYear();
    } else {
      this.year = this.$route.params.year
    }
  },
  watch: {
    $route () {
      this.year = this.$route.params.year
      this.fetchData()
      this.showmore = 0
    }
    //user () {
    //  this.user = this.$parent.$parent.$parent.user
    //}
  },
  beforeRouteUpdate (to, from, next) {
    this.fetchData()
  },
  methods: {
    fetchData: function() {
      this.loaderSm = true
      if(!this.$route.params.year) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/jahresumsaetze/kunde/' + localStorage.getItem('ext-kunde');
        let headers = { 
          'Access-Control-Allow-Origin': '*', 
          'Accept': 'application/json', 
          'app-version': '2.2', 
          'token' : localStorage.getItem('ext-token') 
        };
        let options = { 
          headers: headers
        };
        axios.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, options).then(response => {
          /*
          this.years = response.data;
          */
          this.loaderSm = false
          /*
          this.checkMorris('year-charts');
          */
          this.setYears(response.data)  
          this.drawCustomerGraph()        
        })
        .catch(e => {
          //console.log(e)
        })
      }
      if(this.$route.params.year && !this.$route.params.cat) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde');
        let headers = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token' : localStorage.getItem('ext-token') };
        let options = { headers: headers };
        axios.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, options).then(response => {
          this.categories = response.data;          
          this.loaderSm = false;
          /*
          this.checkMorris('category-charts');
          */
          this.vG2l = 1
          this.vG2r = 1
          //this.drawGraph(1,'vG2l',response.data)
          this.drawGraph(2,'vG2r',response.data)
        })
        .catch(e => {
          //console.log(e)
        })
      }

      if(this.$route.params.year && this.$route.params.cat && !this.$route.params.scat) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde') + '/hatg/' + this.$route.params.cat;
        let headers = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token' : localStorage.getItem('ext-token') };
        let options = { headers: headers };
        axios.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, options).then(response => {
          this.subcategories = response.data;          
          this.loaderSm = false;
          /*
          this.checkMorris('subcategory-charts');
          */
          this.vG3l = 1
          this.vG3r = 1
          //this.drawGraph(1,'vG3l',response.data)
          this.drawGraph(2,'vG3r',response.data)
        })
        .catch(e => {
          //console.log(e)
        })
      }

      if(this.$route.params.year && this.$route.params.cat && this.$route.params.scat) {
        var url = 'https://crm.hennig-fahrzeugteile.de:17120/statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde') + '/hatg/' + this.$route.params.cat + '/atg/' + this.$route.params.scat;
        let headers = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token' : localStorage.getItem('ext-token') };
        let options = { headers: headers };
        axios.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, options).then(response => {
          this.brands = response.data;          
          this.loaderSm = false;
          /*
          this.checkMorris('brand-charts');
          */
          this.vG4l = 1
          this.vG4r = 1
          //this.drawGraph(1,'vG4l',response.data)
          this.drawGraph(2,'vG4r',response.data)
        })
        .catch(e => {
          //console.log(e)
        })
      }
    },
    drawGraph: function(id,prop,datas) {
      
      var dataLj = [
        [
          datas[0].id,
          datas[1].id,
          datas[2].id,
          datas[3].id, 
          datas[4].id,
        ],
        [
          datas[0].name,
          datas[1].name,
          datas[2].name,
          datas[3].name, 
          datas[4].name,
        ],
        [
          datas[0].umsatzLj,
          datas[1].umsatzLj,
          datas[2].umsatzLj,
          datas[3].umsatzLj, 
          datas[4].umsatzLj,
        ],
        [
          datas[0].umsatzVj,
          datas[1].umsatzVj,
          datas[2].umsatzVj,
          datas[3].umsatzVj, 
          datas[4].umsatzVj,
        ]
      ];

      //console.log(dataLj)

      var sortedVj = this._.sortBy(datas, ['umsatzVj']);
      var dataVj = [
        [
          sortedVj[0].id,
          sortedVj[1].id,
          sortedVj[2].id,
          sortedVj[3].id, 
          sortedVj[4].id
        ],
        [
          sortedVj[0].name,
          sortedVj[1].name,
          sortedVj[2].name,
          sortedVj[3].name, 
          sortedVj[4].name
        ],
        [
          sortedVj[0].umsatzVj,
          sortedVj[1].umsatzVj,
          sortedVj[2].umsatzVj,
          sortedVj[3].umsatzVj, 
          sortedVj[4].umsatzVj
        ]

      ];

      var greys = ['#878787','#9d9d9c','#b2b2b2','#dadada','#ededed'];
      var colors = ['#003366','#1d71b8','#00a19a','#66aa66','#006633'];
      var mixed = [];

      //console.log( this._.intersection(dataLj, dataVj) )

      console.log(dataLj[1])
      console.log(dataVj[1])

      if(id==1) {
        var tmpGreys = [], tmpColors = [];

        for(var i=0;i<dataLj[1].length;i++) {
          //console.log( dataLj[0][i] )
          var res = this._.findIndex(dataLj[1], function(o) { return o == dataVj[1][i]; });
          
          if(res!=-1) { // gefunden
            //console.log('gefunden')
            mixed.push(colors[i])
          } else { // nicht gefunden
            //console.log('nicht gefunden')
            mixed.push(greys[i])
          }
        }

        //console.log(mixed)

        /*var tmpColors = [];
        tmpColors.push('red')
        tmpColors.push('green')
        tmpColors.push('blue')
        tmpColors.push('yellow')
        tmpColors.push('purple')*/

        var data = dataVj[2];
        var color = d3.scaleOrdinal(mixed);
      } else {
        var data = dataLj[2];
        var color = d3.scaleOrdinal(colors);
      }

      var pie_chart = c3.generate({
          bindto: "#" + prop + '-' + id,
          size: { width: 300, height: 300 },
          color: {
              pattern: colors
          },
          data: {
              columns: [
                  [dataLj[1][0], dataLj[2][0]],
                  [dataLj[1][1], dataLj[2][1]],
                  [dataLj[1][2], dataLj[2][2]],
                  [dataLj[1][3], dataLj[2][3]],
                  [dataLj[1][4], dataLj[2][4]]
              ],
              type : 'pie'
          }
      });

      /*
      $("#" + prop + '-' + id).find('g').remove()

      var svg = d3.select("#" + prop + '-' + id),
          width = svg.attr("width"),
          height = svg.attr("height"),
          radius = Math.min(width, height) / 2,
          g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

      // Generate the pie
      var pie = d3.pie();

      // Generate the arcs
      var arc = d3.arc()
                  .innerRadius(0)
                  .outerRadius(radius);

      //Generate groups
      var arcs = g.selectAll("arc")
                  .data(pie(data))
                  .enter()
                  .append("g")
                  .attr("class", "arc")

      //Draw arc paths
      arcs.append("path")
          .attr("fill", function(d, i) {
              return color(i);
          })
          .attr("d", arc);  
          */    
    },
    drawCustomerGraph: function() {
      console.log(this.yearslist[0][0].umsatz)
      var chart = c3.generate({
        bindto: '#chartHkCustomer',
        size: {
            height: 240
        },
        padding: {
            //top: 40,
            //right: 30,
            //bottom: 40,
            //left: 100,
        },
        color: {
            pattern: ['blue', 'green']
        },
        data: {
          x: 'x',
            xFormat: '%Y', // 'xFormat' can be used as custom format of 'x'
          columns: [
              ['x', '2014', '2015', '2016', '2017'],
    //            ['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
              ['Umsatz', this.yearslist[0][3].umsatz, this.yearslist[0][2].umsatz, this.yearslist[0][1].umsatz, this.yearslist[0][0].umsatz],
              ['Erloes', this.yearslist[0][3].erloes, this.yearslist[0][2].erloes, this.yearslist[0][1].erloes, this.yearslist[0][0].erloes],
          ]
        },
        axis: {
            x: {
                type: 'timeseries',
                tick: {
                    format: '%Y'
                }
            }
        }
      });
    },
    setYears: function(data) {
      var ret = []
      var retReversed = []
      for(var i = 0;i < data.length;i++) {
        ret[i] = data[i]
        retReversed[i] = data[i]
      }
      retReversed = retReversed.reverse()
      this.yearslist.push(ret)
      this.yearslist.push(retReversed)
    },
    setYear(year) {        
      this.year = year;
      this.fetchData();
    },
    closeSettings() {
      this.settings = false
    },
    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setName(type,value) {
      if(type=='hatg') {
        this.names.hatg = value
      }
      if(type=='atg') {
        this.names.atg = value
      }
      if(type=='brand') {
        this.names.brand = value
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// StatsMaincategory.vue?060a7f5a